import request from '@/utils/httpRequest'

// 发布activity
export function activityOperate(data) {
  return request({
    url: `/activity/publish`,
    method: 'post',
    data
  })
}
// 删除activity
export function activityDelete(id) {
  return request({
    url: `/activity/delete`,
    method: 'post',
    data: [id]
  })
}

// 获取文章分页列表
export function getActivityList(params) {
  return request({
    url: `/activity/list_page`,
    method: 'get',
    params
  })
}
// 获取活动参加用户和积分情况
export function getUserList(params) {
  return request({
    url: `/activity/activity_join_user_list`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'get',
    params
  })
}
// 获取报名人员信息
export function getSignUpUsers(params) {
  return request({
    url: '/activity/registration_user',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    method: 'get',
    params
  })
}

// 添加活动参加用户
export function addJoinUsers(data) {
  return request({
    url: '/activity/add_activity_join_user',
    method: 'post',
    data
  })
}
// 添加活动参加用户积分
export function addJoinUserMarks(data) {
  return request({
    url: '/activity/add_activity_user_point',
    method: 'post',
    data
  })
}
